import tradingModalStore from 'global/TradingModal/store';
import securitiesLocalStorage from 'utils/securitiesLocalStorage';
import { tradingErrorModalList } from 'global/MainLayout/ModalErrorMessage/constants';
import useMultiPortfolioStore from 'lib/stores/multiPorto';
import useAuthModalStore from './store';
import { AUTH_MODAL_CONFIG } from './constants';
import { isRedirectToNewCore as isNewCoreUser } from '../utils';
import { ITradingModalConfig } from './types';

export const showTradingModalWithAuth = async (
  tradingModalConfig: ITradingModalConfig,
  needLoginCallback?: () => void,
) => {
  const tradingType = securitiesLocalStorage.getTradingAccountType();
  const showAuthModal = useAuthModalStore.getState().showModal;
  const showTradingModal = tradingModalStore.getState().showModal;
  const { getTradingBalance } = useMultiPortfolioStore.getState();

  if (!tradingType) {
    showAuthModal(tradingModalConfig);
    if (needLoginCallback) {
      needLoginCallback();
    }
    return;
  }

  if (tradingType === 'virtual') {
    showTradingModal({
      ...tradingModalConfig,
      orderType: AUTH_MODAL_CONFIG[tradingType][tradingModalConfig.orderType],
    });
    return;
  }

  const res = await getTradingBalance();
  if (res?.aggregated_portfolio_summary) {
    showTradingModal({
      ...tradingModalConfig,
      orderType: AUTH_MODAL_CONFIG[tradingType][tradingModalConfig.orderType],
    });
  }
};

export const getAuthModalError = (
  errorCode: string | number,
  errorType: string,
) => {
  if (isNewCoreUser() && errorType) {
    return errorType !== 'INVALID_CREDS';
  }

  const errorTradingModalConfig =
    tradingErrorModalList?.[errorCode]?.[errorType];
  return !!errorTradingModalConfig;
};
